import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import { getAllReportsData, getBankPaymentsData } from "../../../../utils/apis/Inward/Inward";
import Pagination from "../../../common/Pagination";
import { formatDate } from "../../../../utils/common";
import ScreenShot from "../../../common/ScreenShot";
import { Context } from "../../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import EditAmount from "../../../common/EditAmont";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../../../common/common-offcanvas/Filter_offcanvas";

const Reports = ({
  status,
  setStatus,
  handleExportCSV,
  handlePrint,
  handleExportExcel, isAllow
}) => {

  const {id} = useParams();
  const { IMG_URL } = useContext(Context);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    alert(JSON.stringify(data));
  };

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [modalShow, setModalShow] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [inwardID, setID] = useState(false);
  const [previousAmount, setAmount] = useState("");

  const getData = async () => {
    const res = await getBankPaymentsData(currentPage, perPage,
      getValues("contact"),
      getValues("name"),
      getValues("from"),
      getValues("to"),
      getValues("state_id")?.value,
      getValues("city_id")?.value,id);
    setData(res.data);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setTotalEntries(res?.data?.totalEntries);
    setTotalPages(res?.data?.totalPages);
  };

  useEffect(() => {
    getData();
  }, [perPage, currentPage, status]);
  const [modalShow2, setModalShow2] = React.useState(false);
  return (
    <div className="search-investor mt-4">
      <p className="sub">Report</p>

      <div className="d-flex justify-content-end">
  <p><b>Total Amount:- </b> ₹ {data?.totalAmount ?? 0}</p>
</div>


      {isAllow?.includes(39) ? (
        <div className="inward-payment">
          <div className="nav-link active">
            <div className="dt-buttons btn-group flex-wrap">
              <button
                className="btn btn-secondary buttons-excel buttons-html5 ml-1 Excel_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handleExportExcel(data, "Report")}
              >
                <span>Excel</span>
              </button>
              <button
                className="btn btn-secondary buttons-csv buttons-html5 CSV_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handleExportCSV(data, "Report")}
              >
                <span>CSV</span>
              </button>
              <button
                className="btn btn-secondary buttons-print Print_btn"
                tabindex="0"
                aria-controls="DataTables_Table_0"
                type="button"
                onClick={() => handlePrint(data, "Report")}
              >
                <span>Print</span>
              </button>

              <input type="number" className="ps-3" onChange={(e) => setperPage(e.target.value)} placeholder="Enter Per Page Data"></input>
            </div>
          </div>
          <div className="filterdiv">
            <button onClick={() => setModalShow2(true)} className="filterbtn">
              <FontAwesomeIcon icon={faFilter} />
              &nbsp;Filter
            </button>
          </div>


        </div>
      ) : (
        <></>
      )}
      {/* table started */}
      <div className="table-main">
        <div className="table-responsive mt-2">
          <table className="table table-bordered  table-striped">
            <thead>
              <tr>
                <th className="name">
                  Payment Date
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Investor Name
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Service No
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  Bank Name
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                <th className="name">
                  UTR ID
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>

                <th className="name">
                  Amount
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th>
                {/* <th className="name">
                  Action
                  <div className="triangle"></div>
                  <div className="triangle2"></div>
                </th> */}
              </tr>
              {/* )} */}
            </thead>
            <tbody>
              {data?.data?.map((data, index) => (
                <tr className="odd" key={index}>
                  <td>{formatDate(data?.createdAt)}</td>
                  <td>
                    {data?.user?.f_name} {data?.user?.l_name}
                  </td>
                  <td>{data?.user?.contact_no}</td>
                  <td>{data?.bank_account && (<>{data?.bank_account?.bank_name} ({data?.bank_account?.firm_name})</>)}</td>
                  <td>{data?.utr_id}</td>
                  <td>
                    ₹ <b>{data?.amount}{" "}</b>
                    
                  </td>
                  {/* <td>{data?.accepted_rejected ? "Accepted" : "Rejected"}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* table ended */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        TotalPages={TotalPages}
        TotalEntries={TotalEntries}
        perPage={perPage}
      />

      <ScreenShot show={modalShow} onHide={() => setModalShow(false)} />
      <EditAmount
        show={editModal}
        onHide={() => setEditModal(false)}
        inwardID={inwardID}
        getData={getData}
        previousAmount={previousAmount}
      />

      {["end"].map((placement, idx) => (
        <Filter_offcanvas
          placement={placement}
          key={idx}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          setValue={setValue}
          getValues={getValues}
          getData={getData}
          register={register}
          reset={reset}
          control={control}
        />
      ))}
    </div>
  );
};

export default Reports;
